import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const CardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  padding: 24px;
  border-radius: 12px;
  height: max-content;
  background-color: ${colors.background};
  flex: 1;
  margin: 24px 0;
  gap: 16px;

  @media screen and (max-width: 1320px){
    margin: 24px 20px;
    padding: 16px;
  }
`
